import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { IIconProps } from '../Helpers/Common';

export enum Display {
	Solid = 'btn--solid',
	Outline = 'btn--outline',
	Text = 'btn--text',
	None = '',
}

export enum Colors {
	Primary = 'btn--primary',
	Secondary = 'btn--secondary',
	Warning = 'btn--warning',
	Error = 'btn--error',
	Success = 'btn--success',
	None = '',
	Disabled = 'btn--disabled',
	Alternate = 'btn--alternate',
	BookNow = 'btn--book_now',
	Red = 'btn--cancel-red',
	Black = 'btn--high-emphasis',
	White = 'btn--white',
	Grey = 'btn--grey',
}

export enum Sizes {
	ExtraSmall = 'btn--xsm',
	Small = 'btn--sm',
	Medium = 'btn--md',
	Large = 'btn--lg',
	ExtraLarge = 'btn--xlg',
	None = '',
}

export enum Widths {
	auto = 'btn--auto-width',
	fullWidth = 'btn--full-width',
}

export enum QuickTypes {
	Primary = 'btn--primary',
	Secondary = 'btn--secondary',
	None = '',
}

export interface ICbButtonProps {
	type?: 'submit' | 'reset' | 'button';
	display?: Display;
	colors?: Colors;
	sizes?: Sizes;
	widths?: Widths;
	quickTypes?: QuickTypes;
	buttonProps?: React.ButtonHTMLAttributes<Element>;
	children?: React.ReactNode;
	className?: string;
	disabled?: boolean;
	onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	icon?: IIconProps;
	labelVisible?: false;
	value?: string;
	newStyles?: boolean;
}

export const Button = observer((props: ICbButtonProps) => {
	const {
		labelVisible: labelVisibleProp,
		type,
		quickTypes: quickTypesProp,
		widths: widthsProp,
		sizes: sizesProp,
		children,
		onClick: onClickProp,
		icon: iconProp,
		display: displayProp,
		colors: colorsProp = Colors.Primary,
		className: classNameProp,
		buttonProps,
		value,
		newStyles,
		disabled,
	} = props;
	const icon = iconProp ? `btn--icon icon-${iconProp.icon} ${iconProp.iconPos}` : '';
	const quickTypes = quickTypesProp ?? '';
	const display = displayProp ?? '';
	const colors = colorsProp ?? '';
	const sizes = sizesProp ?? '';
	const widths = widthsProp ?? '';
	const className = classNameProp ?? '';

	const clazz = ['btn', icon, quickTypes, display, colors, sizes, widths, className];

	const onClick = onClickProp ?? buttonProps?.onClick;

	const labelVisible = labelVisibleProp === undefined ? true : labelVisibleProp;
	const label = typeof children === 'string' ? children : undefined;

	return (
		<button
			type={type ?? 'button'}
			value={value}
			onClick={onClick}
			className={classNames(clazz, { 'new-style': newStyles })}
			aria-label={!labelVisible ? label : undefined}
			disabled={disabled}
			{...buttonProps}
		>
			{labelVisible ? children : null}
		</button>
	);
});
